import React from 'react'
import SetUpAccountPage from '../../components/Fundraiser/FundraiserOnboarding/SetUpAccount';

const SetUpAccount = () => {
  return (
    <SetUpAccountPage />
  )
}

export default SetUpAccount;